<template>
  <v-avatar :color="avatarClass" :size="size" :class="{ 'highlight-avatar': highlightAvatar }">
    <img v-if="profilePicture" :src="profilePicture" />
    <span v-if="!profilePicture && user" class="white--text ">
      {{ user.firstName ? user.firstName.charAt(0).toUpperCase() : ""
      }}{{ user.lastName ? user.lastName.charAt(0).toUpperCase() : "" }}</span
    >
  </v-avatar>
</template>

<script>
export default {
  name: "UserAvatar",
  props: {
    user: {
      type: Object,
      required: false,
    },
    profilePicture: {
      type: String,
      required: false,
    },
    size: {
      type: String,
      default: "40",
    },
    highlightAvatar: {
      type: Boolean,
      default: false,
    },
    highlightColour: {
      type: String,
      default: "#3ADEB4",
    },
  },
  computed: {
    avatarClass() {
      if (this.highlightAvatar) {
        return this.highlightColour;
      }

      if (this.profilePicture) {
        return "white";
      }
      return "navy";
    },
  },
};
</script>

<style scoped lang="scss">
.highlight-avatar {
  border: 3px solid;
}
</style>
